{
  "zh-CN": {
    "texts": {
      "index": "Your database for all information around Ships and Stations in Star Citizen.",
      "indexQuote": "“Strap into one of dozens of ships and embark on a life within the Star Citizen universe.<br>Unbound by profession or skill sets, you choose the path of your own life.”",
      "indexQuoteSource": "Author Unknown, Source:",
      "support": {
        "info": "喜欢 FleetYards.net 吗？为我们的 <a href=\"https://robertsspaceindustries.com/spectrum/community/SC/forum/57219/thread/fleetyards-net\" target=\"_blank\" rel=\"noopener\"><b>Spectrum 帖子</b></a> 点赞来帮助我们成长 — 这是免费的，还能提升我们在社区中的曝光度。",
        "goal": "每月目标用于帮助支付 FleetYards 的运营成本，例如服务器托管和数据服务。每一份支持都有助于让网站保持在线、快速且及时更新。",
        "code": "Additionally you can get 5000 UEC starting money by using the following Recruitment Code when you buy Star Citizen:",
        "subline": "或者您可以直接通过以下方式支持我们：",
        "thisMonth": "本月已筹集"
      },
      "supportHint": {
        "hangarSync": "后台同步是我们托管账单中最大的一项支出。FleetYards 依靠捐赠运行 — 任何支持都很重要。",
        "vehicleAdded": "FleetYards 免费、无广告,完全依靠捐赠运行。如果它对你有帮助,一份小小的捐助就能维持它的运转。",
        "fleetCreated": "舰队是我们最耗资源的功能之一。FleetYards 凭借捐赠保持免费和无广告 — 欢迎你也加入支持。",
        "loginMilestone": "你已经陪伴我们一段时间了 — 谢谢。FleetYards 依靠捐赠运行;如果你愿意帮忙分担费用,这里可以了解更多。",
        "visitMilestone": "FleetYards 由社区资助 — 没有广告,没有付费墙。如果你觉得它有用,一份小小的捐赠就能起到很大作用。"
      },
      "notFound": "You are currently venturing unknown space. In the event you are lost, the UEE highly recommends plotting a new destination back towards home-space.",
      "forbidden": "你的权限不包含此区域。如果某项功能仍在灰度发布中，等它对你开放后，可以在“设置 > 功能”中自行开启。",
      "featureNotReady": "此功能尚未完成，即将推出。敬请期待！",
      "accessDenied": "您无权查看此页面。",
      "serverError": "服务器当前遇到技术问题。请稍后再试。",
      "compare": {
        "ships": {
          "info": "To start select at least two and not more than eight Ships you want to compare."
        }
      },
      "fleets": {
        "leaveInfo": "You can not leave a Fleet as an Admin."
      },
      "admin": {
        "destroyedFleets": {
          "purgedWarning": "恢复已清除的舰队只是尽力而为。角色、图片、邀请链接和舰队载具不会被恢复。"
        },
        "models": {
          "viewsFolder": {
            "hint": "拖入一个视图文件夹，文件命名为 top.png、side.png、front.png 和 angled.png。带涂装的一组加后缀 _colored，展开状态的一组加前缀 extended_。holo.gltf 和 extended_holo.gltf 也会一并上传。",
            "uploading": {
              "one": "正在上传 1 个文件…",
              "other": "正在上传 %{count} 个文件…"
            },
            "matched": {
              "one": "1 个文件已就绪 — 保存以应用。",
              "other": "%{count} 个文件已就绪 — 保存以应用。"
            },
            "ignored": "已忽略: %{files}"
          }
        }
      },
      "hangarGuide": {
        "add": "To add a new ship to your hangar visit the ships page and click on the bookmark icon in the top right corner of the ship you want to add.<br>Alternatively you can add a ship on its detail page, the button is located on the right side below the stats boxes.<br>You can click multiple times on the icon if you want more than one ship of the same type.",
        "edit": "To edit a ship just click on the pencil icon in the top right corner of the ship you want to edit.",
        "wishlist": "To add a new ship to your wishlist visit the ships page and click on the bookmark icon in the top right corner of the ship you want to add.<br>Alternatively you can add a ship on its detail page, the button is located on the right side below the stats boxes.",
        "groups": {
          "add": "To add a group just click on the plus icon in the line prefixed by \"groups\".",
          "edit": "To edit a group make a right click on the group you want to edit."
        },
        "fleetchart": "To view a scaled fleetchart of your ships from an above view angle just click on the \"Fleetchart\" button over your ship list.<br>In the fleetchart mode you can scale the ships.<br>To save a transparent png of your fleetchart please visit the public page of your hangar.",
        "public": "Your hangar has a public visible page where all ships are listed. You can access your public hangar by clicking on the \"Public URL\" button in the top right corner.",
        "icon": "注意这个图标："
      },
      "hangarPreview": {
        "notified": {
          "headline": "获取新飞船和促销通知",
          "text": "Get notified once a new Ship is released on <a href=\"https://robertsspaceindustries.com\" target=\"_blank\" rel=\"noopener\">robertsspaceindustries.com</a> and never miss a Sale. You can also enable Sale Notifications for Ships in your Hangar."
        },
        "manage": {
          "headline": "管理您的机库",
          "text": "Add Ships to your Hangar, name your Ships, mark them as wanted or get notified if a Ship gets on Sale. Decide which Ship you want to show on your Public Hangar. Get further Insides into your Hangar: Which Roles can your Ships fulfil? How many Ships are Flight Ready? What is your main Manufacturer? How much money did you spend?"
        },
        "fleetchart": {
          "headline": "舰队图表和公开机库",
          "text": "View your Ships as a scaled topview Fleetchart and export it as an image. Get a Public Hangar page which you can share with others, you decide what Ships will be visible on your Public Hangar."
        }
      },
      "fleetPreview": {
        "notified": {
          "headline": "分析",
          "text": "View stats of your Fleet - analyze and optimize for roles, cargo capacity etc."
        },
        "overview": {
          "headline": "概览与管理",
          "text": "Invite your Org Mates and get a filterable and searchable list of all public Ships. "
        },
        "fleetchart": {
          "headline": "舰队图表",
          "text": "View your Fleet as a scaled topview Fleetchart and export it as an image."
        }
      },
      "impressum": {
        "visit": "访问",
        "ytShipImages": "The Awesome Ship Images in the Hangar Fleetchart view are the work of <a href=\"https://twitter.com/WhyTeeZero\" target=\"_blank\" rel=\"noopener\">YT (Twitter: @WhyTeeZero)</a>.<br>Please visit his Spectrum post (see links below) and give him a upvote.",
        "erkul": "The ship metrics on Fleetyards are modelled on the formulas and readouts of Erkul's DPS Calculator. Thanks to the erkul.games team for sharing their work with the community.",
        "appSignal": "AppSignal provided a sponsored Open Source Account which helps to improve Fleetyards.net even further. Thanks :)",
        "copyright": "The contents and works created by the page operators, on these pages are subject to German copyright. Duplication, processing, distribution and any kind of exploitation outside the limits of Copyright require the written consent of the respective author or creator. Downloads and copies of this page are only for private, non-commercial use. Insofar as the content on This page was not created by the operator, are third-party copyrights respected. In particular, Third-party content as such. Please Contact us if you notice any sort of copyright infringement. We will remove any content immediately as we become aware of such violations.",
        "disclaimer": {
          "p1": "This is an unofficial Star Citizen fansite, not affiliated with the Cloud Imperium group of companies.",
          "p2": "All content on this site not authored by its host or users are property of their respective owners.",
          "p3": "Star Citizen®, Squadron 42®, Roberts Space Industries®, and Cloud Imperium® are registered trademarks of Cloud Imperium Rights LLC. All rights reserved."
        },
        "liabilityInternal": {
          "p1": "The content of out site has been compiled with meticulous care and to the best of our knowledge. However, We cannot assume any liability for the up-to-dateness, completeness or accuracy of any of the pages.",
          "p2": "Pursuant to section 7, para. 1 of the TMG (Telemediengesetz), We are liable for our own content on these pages in accordance with general laws. However, pursuant to sections 8 to 10 of the TMG, We are not under obligation to monitor external information provided or stored on our site. Once We have become aware of a specific infringement of the law, We will immediately remove the content in question. Any liability concerning this matter can only be assumed from the point in time at which the infringement becomes known to us."
        },
        "liabilityExternal": "Our site contains links to websites of third parties (“external links”). As the content of these sites is not under our control, We cannot assume any liability for such external content. In all cases, the provider of information of the linked sites is liable for the content and accuracy of the information provided. At the point in time when the links were placed, no infringements of the law were recognisable to us. As soon as an infringement of the law becomes known to us, We will immediately remove the link in question."
      },
      "privacy": {
        "text": "The use of our site is usually possible without providing any personal data. The collecting of personal data (eg email address) on our sites will be, as far as possible, on a voluntary basis. No personal data will be passed on to third parties without your explicit consent.<br>We point out that data transmission over the Internet (eg when communicating by email) can have security gaps. A complete protection of data against access by third parties is not possible.",
        "p1": "Below you can read about what Information we are using to provide you the services on %{app}. For most parts this only concerns registered Users but please read further to get a full overview.",
        "p2": {
          "headline": "我们使用哪些信息?",
          "text": "Depending on if you are a registered User or only using %{app} as a Guest we use more or less Information from you."
        },
        "p3": {
          "headline": "作为访客",
          "text": "作为 %{app} 的访客，我们收集以下数据："
        },
        "analytics": {
          "headline": "使用情况分析",
          "basis": "%{app} 会统计页面访问量，以了解网站的哪些部分真正被使用。这基于我们运营和改进网站的合法利益，而非您的同意: 数据仅由我们第一方收集，IP 地址在存储前已匿名化，不会在您的设备上放置 Cookie 或其他标识符，也不会与任何广告网络共享。",
          "retention": "单次访问和页面浏览记录会在一个月后删除。此后仅保留无法追溯到个人的汇总数据。删除您的账户也会同时删除为其记录的访问数据。",
          "objection": {
            "headline": "如何反对",
            "text": "您可以随时反对使用情况分析，我们会真正停止记录，而不仅仅是将其隐藏。",
            "user": "您在“设置”中的账户选项会应用到您登录的每一台设备。",
            "guest": "没有账户时，您可以在此反对。如果您的浏览器发送了 Global Privacy Control 信号，我们也会予以尊重。"
          }
        }
      },
      "settings": {
        "privacy": {
          "tracking": "启用后，我们会统计您访问的页面，以了解网站的哪些部分被使用。IP 地址会被匿名化，不会在您的设备上存储任何内容，单次访问记录会在一个月后删除。关闭后将完全停止记录。"
        },
        "notifications": {
          "hint": "选择每类事件如何通知您。应用内通知会汇集在您的通知中心，邮件将发送到您账户的邮箱地址。"
        }
      },
      "signup": {
        "blocked": "You have been blocked from FleetYards.net.<br>This can have multiple Reasons.<br>For further Information please Contact us under info ( at ) fleetyards.net"
      },
      "roadmap": {
        "inactive": "This Item was removed from the Roadmap. This is its last location"
      },
      "twoFactor": {
        "backupCodes": "Save a copy of your Backup-Codes. They will only be visible this one time.",
        "disable": "要禁用两步验证，只需输入一个有效的令牌。",
        "enable": " To secure your FleetYards.net Account you can generate 2-Factor-Auth Tokens with Google Authenticator, 1Password or Authy."
      },
      "oauthAuthorize": {
        "requestingAccess": "{clientName} 正在请求访问您的账户。",
        "scopesIntro": "此应用将能够："
      },
      "syncExtension": {
        "gettingStarted": "To sync your RSI Hangar with Fleetyards you first need to install the Fleetyards Sync Extension for Firefox or Chromium based Browsers.",
        "info": "We will try to match the ships from your RSI Hangar with your exisiting ships in your Fleetyards Hangar by using the name and the pledge-id. Ships from the RSI Hangar without a match will be added to your Fleetyards Hangar and ships from your Fleetyards Hangar which could not be found in your RSI Hangar will be moved to your Wishlist.<br><br>Do you want to continue?",
        "alreadyRunning": "机库同步已在进行中。请等待完成。"
      },
      "setEmail": "要设置密码、启用双重认证或接收邮件通知，您需要为账户添加电子邮件地址。您将收到一封确认邮件来验证该地址。",
      "empty": {
        "hangar": {
          "info": "You can add Ships to your Hangar by clicking on the bookmark icon in the top right corner of a Ship or by using the Plus Button in the bottom right corner.",
          "extension": "Additionally you can import your Hangar from the RSI Website via the Fleetyards Sync Browser extension."
        },
        "wishlist": {
          "info": "You can add Ships to your Wishlist by clicking on the bookmark icon in the top right corner of a Ship."
        }
      }
    }
  }
}
